

export const CotizacionInfo = ({ formulario, setFormulario, fechaCreacion, setMostrarCalendario }) => {
    
    const actualizarCampoRequerimiento = (valor) => {
        setFormulario((prev) => ({
            ...prev,
            nombreEvento: valor,
        }));
    };
    return (
        <div className="border rounded p-4 shadow-sm bg-light">
            <h4 className="mb-3 text-dark font-weight-bold">Información de la Cotización</h4>
            <div className="mb-3">
                <h5 className="mb-1 text-grey">Fecha cotización:</h5>
                <p className="mb-0">{fechaCreacion}</p>
            </div>
            <hr />
            <div className="mb-3">
                <h5 className="mb-1 text-grey">Nombre del evento:</h5>
                <input
                    type="text"
                    onChange={(e) => actualizarCampoRequerimiento( e.target.value)}
                    value={formulario.nombreEvento}
                    className="form-control"
                    placeholder="Nombre del evento"
                />
            </div>
            <hr />
            <div className="mb-3">
                <h5 className="mb-1 text-grey d-flex align-items-center">
                    <span className="me-3">Fecha Evento: Calendario</span>
                    <div className="form-check form-switch">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            value={formulario.mostrarCalendario}
                            onChange={(e) => setMostrarCalendario(e.target.checked)}
                            style={{ transform: "scale(1.5)" }}
                        />
                    </div>
                </h5>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
        </div>
    );
};
